// import config from '../utils/config';
import actionTypes from './action-types';
import tclocal from '../ter/ter-consts-local-lib';
import { actionShowToast, actionRouteRefresh, actionNotificationsFromSupervalidator } from './actions';
import ajax from '../utils/ajax-adapter';
import { ajax_fetch } from '../utils/frfr-ajax-fetch';
import { frfr_res_utils } from '../utils/frfr-res-utils';
import { terSuperValidatorAll } from '../ter/ter-super-validator-lib';
import { _update_virtelArr_with_genus_ident } from '../ter/ter-virtel-utils';
import { lib_cnc_s4_program_template_cache_set, lib_ter_document_cache_set, lib_ter_materijal_lim_cache_set, lib_ter_virtel_params_cache_set, lib_ter_cparams_cache_set } from '../ter/ter-cache-utils';


// -------- UTILS --------

export const errCatched = (error) => {
  // console.log(error);
  console.error(error);
};


// ---------- SIMDB ACTIONS ---------


export const actionDevSimDbGet = () => {
  return (dispatch) => {
    // NOVO 2021april
    dispatch({ type: actionTypes.ADMIN_SIMDB_GET_WHOLE_FETCHING });
    ajax.getDevDbWhole()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        console.log('ajax.getDevDbWhole rsponse', response);
        dispatch({
          type: actionTypes.ADMIN_SIMDB_GET_WHOLE_FETCHED,
          payload: response
        });
      })

  };
};


export const actionAdminDbInitialSeed = () => {
  return (dispatch) => {
    // NOVO
    dispatch({ type: '**INFO_inicijalni_seed_baze_ZAPOCET' });
    ajax.postAdminDbInitialSeed()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // console.log(response);
        dispatch({ type: '**INFO_inicijalni seed baze USPEH' });
        dispatch(actionShowToast('...Verovatno smo napunili bazu PROVERI'));
      })

  };
};


export const actionAdminDbDelete = () => {
  return (dispatch) => {
    // NOVO
    dispatch({ type: '**INFO_brisanje_baze_ZAPOCETO' });
    ajax.postAdminDbDelete()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // console.log(response);
        dispatch({ type: '**INFO_brisanje_baze_USPEH' });
        dispatch(actionShowToast('...Verovatno ste obrisali bazu PROVERI'));
      })

  };
};


// ---------- INIT ACTIONS --------


export const actionInitializedAll = () => {
  return (dispatch) => {
    //
    dispatch({ type: actionTypes.INITIALIZED_ALL });
    dispatch(actionShowToast('Aplikacija inicijalizovana', tclocal.GREEN));
    //
  };
};


export const actionInitializedVirtelSchemaOptimized = () => {
  return (dispatch) => {
    //
    dispatch({ type: actionTypes.INITIALIZED_VIRTEL_SCHEMA_OPTIMIZED });
    // dispatch(actionShowToast('Optimizovana virtel_schema', tclocal.GREEN));
    //
  };
};


export const actionInitLibVirtelParams_OLD = () => {
  return (dispatch) => {
    //
    dispatch({ type: actionTypes.INITIALIZED_LIB_VIRTEL_PARAMS });
    //
  };
};
export const actionInitLibVirtelParams = () => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.LIB_VIRTEL_PARAMS_LIST_FETCHING });
    // korak 2 - fetchujemo podatke
    ajax.getLibVirtelParamsList()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        console.log('response od getLibVirtelParamsList', response);
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          if (Array.isArray(res_payload)) {
            // setLibItems(res_payload);
            if (lib_ter_virtel_params_cache_set(res_payload)) {
              dispatch({ type: actionTypes.INITIALIZED_LIB_VIRTEL_PARAMS });
              dispatch(actionShowToast('Biblioteka Virtel Params keširana', tclocal.GREEN));
            }
          }
          // dispatch({ type: actionTypes.LIB_MATERIJAL_LIM_LIST_SUCCESS, payload: res_payload })
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.LIB_VIRTEL_PARAMS_LIST_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)
  };
};


export const actionInitLibMaterijalLim = () => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.LIB_MATERIJAL_LIM_LIST_FETCHING });
    // korak 2 - fetchujemo podatke
    ajax.getLibMaterijalLimParamsList()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        console.log('response od getLibMaterijalLimParamsList', response);
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          if (Array.isArray(res_payload)) {
            // setLibItems(res_payload);
            if (lib_ter_materijal_lim_cache_set(res_payload)) {
              dispatch({ type: actionTypes.INITIALIZED_LIB_MATERIJAL_LIM });
              dispatch(actionShowToast('Biblioteka materijal lim keširana', tclocal.GREEN));
            }
          }
          // dispatch({ type: actionTypes.LIB_MATERIJAL_LIM_LIST_SUCCESS, payload: res_payload })
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.LIB_MATERIJAL_LIM_LIST_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)
  };
};


export const actionInitLibCNCTemplate = () => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.LIB_CNC_S4_TEMPLATE_LIST_FETCHING });
    // korak 2 - fetchujemo podatke
    ajax.getLibCNCProgramS4TemplateList()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        console.log('response od getLibCNCProgramS4TemplateList', response);
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          if (Array.isArray(res_payload)) {
            // setLibItems(res_payload);
            if (lib_cnc_s4_program_template_cache_set(res_payload)) {
              dispatch({ type: actionTypes.INITIALIZED_LIB_CNC_S4_TEMPLATE });
              dispatch(actionShowToast('CNC program S4 template lib keširana', tclocal.GREEN));
            }
          }
          // dispatch({ type: actionTypes.LIB_CNC_S4_TEMPLATE_LIST_SUCCESS, payload: res_payload })
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.LIB_CNC_S4_TEMPLATE_LIST_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)
  };
};


export const actionInitLibDocument = () => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.LIB_DOCUMENT_LIST_FETCHING });
    // korak 2 - fetchujemo podatke
    ajax.getLibDocumentList()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        console.log('response od getLibDocumentList', response);
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          if (Array.isArray(res_payload)) {
            // setLibItems(res_payload);
            if (lib_ter_document_cache_set(res_payload)) {
              dispatch({ type: actionTypes.INITIALIZED_LIB_DOCUMENT });
              dispatch(actionShowToast('Biblioteka Tabela keširana', tclocal.GREEN));
            }
          }
          // dispatch({ type: actionTypes.LIB_DOCUMENT_LIST_SUCCESS, payload: res_payload })
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.LIB_DOCUMENT_LIST_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)
  };
};


export const actionInitLibCparams = () => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.LIB_CPARAMS_LIST_FETCHING });
    // korak 2 - fetchujemo podatke
    ajax.getLibCparamsList()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        console.log('response od getLibCparamsList', response);
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          if (Array.isArray(res_payload)) {
            // setLibItems(res_payload);
            if (lib_ter_cparams_cache_set(res_payload)) {
              dispatch({ type: actionTypes.INITIALIZED_LIB_CPARAMS });
              dispatch(actionShowToast('Biblioteka Cparams keširana', tclocal.GREEN));
            }
          }
          // dispatch({ type: actionTypes.LIB_CPARAMS_LIST_SUCCESS, payload: res_payload })
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.LIB_CPARAMS_LIST_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)
  };
};


// ???
export const actionTerDraftInit = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.DRAFT_INIT });
  };
};


export const actionDraftRefreshSmartbom = () => {
  return (dispatch) => {
    //
    dispatch({
      type: actionTypes.DRAFT_REFRESH_SMARTBOM
    });
    //
  };
};


// ---------- ??? ----------

export const actionDraftDodajKlimaKomora = (entbox, parent_subkey, wizardMode, wizardOperationFreshness, cb) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_KLIMA_KOMORA_DODAJ,
      payload: {
        entbox: entbox,
        parent_subkey: parent_subkey,
        wizardMode,
        wizardOperationFreshness
      }
    });
    if (typeof cb === 'function') {
      cb();
    }
    return Promise.resolve();
  };
};

export const actionDraftIzmeniKlimaKomora = (entbox, subkey) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_KLIMA_KOMORA_IZMENI,
      payload: {
        subkey: subkey,
        entbox: entbox
      }
    });
  };
};

export const actionDraftDuplirajKlimaKomoru = (entbox) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_KLIMA_KOMORA_DUPLIRAJ,
      payload: {
        entbox: entbox
      }
    });
  };
};

export const actionDraftObrisiKlimaKomora = (subkey) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_KLIMA_KOMORA_OBRISI,
      payload: subkey
    });
  };
};

export const actionDraftDodajModul = (entbox, parent_subkey, wizardMode, wizardOperationFreshness) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_MODUL_DODAJ,
      payload: {
        entbox: entbox,
        parent_subkey: parent_subkey,
        wizardMode,
        wizardOperationFreshness
      }
    });
  };
};

export const actionDraftDodajMaterijalCustom = (entbox, parent_subkey, wizardMode, wizardOperationFreshness) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_MATERIJALCUSTOM_DODAJ,
      payload: {
        entbox: entbox,
        parent_subkey: parent_subkey,
        wizardMode,
        wizardOperationFreshness
      }
    });
    return Promise.resolve();
  };
};

export const actionDraftDodajMaterijalCustom_bulk = (entbox, parent_subkey) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_MATERIJALCUSTOM_DODAJ_BULK,
      payload: {
        entbox: entbox,
        parent_subkey: parent_subkey,
      }
    });
    return Promise.resolve();
  };
};

export const actionDraftIzmeniModul = (entbox, subkey, wizardMode, wizardOperationFreshness) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_MODUL_IZMENI,
      payload: {
        subkey: subkey,
        entbox: entbox,
        wizardMode,
        wizardOperationFreshness
      }
    });
  };
};

export const actionDraftDuplirajModul = (entbox) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_MODUL_DUPLIRAJ,
      payload: {
        entbox: entbox
      }
    });
  };
};

export const actionDraftObrisiModul = (subkey) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_MODUL_OBRISI,
      payload: subkey
    });
  };
};

export const actionDraftDodajPoluproizvod = (entbox, parent_subkey, wizardMode, wizardOperationFreshness) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_POLUPROIZVOD_DODAJ,
      payload: {
        entbox: entbox,
        parent_subkey: parent_subkey,
        wizardMode,
        wizardOperationFreshness
      }
    });
    return Promise.resolve();
  };
};

export const actionDraftIzmeniPoluproizvod = (entbox, subkey) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_POLUPROIZVOD_IZMENI,
      payload: {
        subkey: subkey,
        entbox: entbox
      }
    });
  };
};

export const actionDraftDuplirajPoluproizvod = (entbox) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_POLUPROIZVOD_DUPLIRAJ,
      payload: {
        entbox: entbox
      }
    });
  };
};

export const actionDraftObrisiPoluproizvod = (subkey) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DRAFT_POLUPROIZVOD_OBRISI,
      payload: subkey
    });
  };
};


//


/*
export const actionDraftSuperValidateNEBITAN = (draft) => {
  return (dispatch) => {
    // ?
    let cb = (valid, errors) => {
      // znaci da je supervalidator zavrsio i vratio rezultate supervalidacije
      dispatch({
        type: actionTypes.DRAFT_SUPERVALIDATOR_ALL,
        payload: {
          valid,
          errors
        }
      });
    }
    terSuperValidatorAll(draft, cb);
  };
};
*/
// ???
export const actionDraftSuperValidate = (draft) => {
  return (dispatch) => {
    // ?
    let cb = (valid, superErrors) => {
      // znaci da je supervalidator zavrsio i vratio rezultate supervalidacije
      dispatch({
        type: actionTypes.DRAFT_SUPERVALIDATOR_ALL,
        payload: {
          valid,
          superErrors
        }
      });
      if (valid === true) {
        dispatch(actionShowToast('Supervalidator nema upozorenja', tclocal.GREEN));
      } else {
        // dispatch(actionShowToast('Supervalidator pronašao greške', tclocal.RED)); // 2023 PRIVRMEN OISKLJUCENO
      }
      // takodje saljemo notifications
      dispatch(actionNotificationsFromSupervalidator(superErrors.errors));

    }
    terSuperValidatorAll(draft, cb);
  };
};


export const actionDraftRemoveClickedModul = () => {
  return (dispatch) => {
    dispatch({
      type: 'REMOVE_CLICKED_MODULE'
    });
  };
};


// ---------- TER COMORDER ACTIONS --------


export const actionComorderLoad = (comorder, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    // dispatch({ type: actionTypes.COMORDER_LIST_FETCHING });
    // korak 2 - fetchujemo podatke
    dispatch({ type: actionTypes.COMORDER_LOAD, payload: comorder });
    if (typeof cb === 'function') {
      cb(comorder);
    }
  };
};


export const actionComorderListNeeded = () => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.COMORDER_LIST_FETCHING });

    // korak 2 - fetchujemo podatke
    ajax.getComorderList()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          if (Array.isArray(res_payload)) {
            // inicijalno sortiramo pocev od najnovije
            const sortedComorderList = res_payload.sort((a, b) => {
              // if (a._draftelschemakey > b._draftelschemakey) {
              if (a && a.id && b && b.id && a.id > b.id) {
                // return 1; // ascending prvo najmanji
                return -1; // descending prvo najveci
              }
              if (a && a.id && b && b.id && a.id < b.id) {
                // return -1; // ascending prvo najmanji
                return 1; // descending prvo najveci
              }
              return 0;
            });
            dispatch({ type: actionTypes.COMORDER_LIST_SUCCESS, payload: sortedComorderList });
          }
          // dispatch({ type: actionTypes.COMORDER_LIST_SUCCESS, payload: res_payload });
          // dispatch(actionShowToast('Sucess! :)'));
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.COMORDER_LIST_FAIL });
          dispatch(actionShowToast('Greska! :('));
        }
      })
      .catch(errCatched)

  };
};


export const actionComorderCreate = (comorder) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.COMORDER_CREATE_FETCHING });

    // korak 2 - fetchujemo podatke
    // console.log(comorder)
    ajax.postComorderCreate(comorder)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: actionTypes.COMORDER_CREATE_SUCCESS, payload: res_payload })
          dispatch(actionShowToast('comorder uspešno dodat!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.COMORDER_CREATE_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionComorderUpdate = (entbox, id) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.COMORDER_UPDATE_FETCHING, payload: id })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postComorderUpdate(entbox, id)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: actionTypes.COMORDER_UPDATE_SUCCESS, payload: res_payload })
          dispatch(actionShowToast('comorder uspešno izmenjen!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.COMORDER_UPDATE_FAIL })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionComorderFlagDeleted = (id) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.COMORDER_FLAGDELETED_FETCHING, payload: id })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postComorderUpdateFlagDeleted(id)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: actionTypes.COMORDER_FLAGDELETED_SUCCESS, payload: res_payload })
          dispatch(actionShowToast('comorder uspešno obrisan!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.COMORDER_FLAGDELETED_FAIL })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


// ADMIN ACTION UNDELETE
export const actionComorderUndelete = (id) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.COMORDER_UNDELETE_FETCHING, payload: id })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postComorderUpdateUndelete(id)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: actionTypes.COMORDER_UNDELETE_SUCCESS, payload: res_payload })
          dispatch(actionShowToast('comorder uspešno undeleted!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.COMORDER_UNDELETE_FAIL })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


// ---------- TER COMORDITEM ACTIONS ----------


export const actionComorditemListNeeded = () => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.COMORDITEM_LIST_FETCHING });

    // korak 2 - fetchujemo podatke
    ajax.getComorditemList()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: actionTypes.COMORDITEM_LIST_SUCCESS, payload: res_payload });
          // dispatch(actionShowToast('Sucess! :)'));
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.COMORDITEM_LIST_FAIL });
          dispatch(actionShowToast('Greska! :('));
        }
      })
      .catch(errCatched)

  };
};


export const actionTerComorditemCreate = (entbox, cb, reducer_res_key) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.COMORDITEM_CREATE_FETCHING });

    // korak 2 - fetchujemo podatke
    // console.log(entbox)
    ajax.postComorditemCreate(entbox)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        console.log('response postComorditemCreate');
        console.log(response);
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          console.log('res_payload postComorditemCreate');
          if (typeof cb === 'function') {
            cb(res_payload);
          }
          // console.log(response);
          dispatch({
            type: actionTypes.COMORDITEM_CREATE_SUCCESS,
            payload: res_payload
          }); // ovaj se ne koristi verovatno
          /*
          dispatch({
            type: actionTypes.DRAFT_REDUCER_RESPONSE_CREATE,
            payload: {
              res_payload,
              reducer_res_key
            }
          });
          */
          dispatch(actionShowToast('virbom_header uspešno dodat!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
          let created_entity_id = false;
          if (res_payload && res_payload.id) {
            created_entity_id = false;
          }

        } else {
          // console.log(response);
          dispatch({ type: actionTypes.COMORDITEM_CREATE_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionComorditemUpdate = (entbox, id, cb, reducer_res_key) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.COMORDITEM_UPDATE_FETCHING, payload: id })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postComorditemUpdate(entbox, id)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          if (typeof cb === 'function') {
            cb(res_payload);
          }
          // console.log(response);
          /*
          dispatch({
            type: actionTypes.COMORDITEM_UPDATE_SUCCESS,
            payload: res_payload
          });
          */
          dispatch({
            type: '***COMORDITEM_UPDATE_SUCCESS',
            payload: {
              res_payload,
              reducer_res_key
            }
          });
          dispatch(actionShowToast('virbom_header uspešno izmenjen!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.COMORDITEM_UPDATE_FAIL })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionComorditemFlagDeleted = (id) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.COMORDITEM_FLAGDELETED_FETCHING, payload: id })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postComorditemUpdateFlagDeleted(id)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: actionTypes.COMORDITEM_FLAGDELETED_SUCCESS, payload: res_payload })
          dispatch(actionShowToast('comorditem uspešno obrisan!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.COMORDITEM_FLAGDELETED_FAIL })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionComorditemUndelete = (id) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.COMORDITEM_UNDELETE_FETCHING, payload: id })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postComorditemUpdateUndelete(id)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: actionTypes.COMORDITEM_UNDELETE_SUCCESS, payload: res_payload })
          dispatch(actionShowToast('comorditem uspešno undeleted!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.COMORDITEM_UNDELETE_FAIL })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionComorditemUntake = (id, cb, cb_fail) => {
  // USER UNTAKE
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    // dispatch({ type: actionTypes.COMORDER_UNDELETE_FETCHING, payload: id })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postComorditemUpdateUntake(id)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          // posle untake refreshovati spisak
          if (typeof cb === 'function') {
            cb();
          }
          dispatch(actionShowToast('comorditem uspešno otključan!', tclocal.GREEN));
          // dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          // dispatch({ type: actionTypes.COMORDER_UNDELETE_FAIL })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
          if (typeof cb_fail === 'function') {
            cb_fail();
          }
        }
      })
      .catch(errCatched)

  };
};


// ADMIN ACTION UNTAKE
export const actionComorditemAdminUntake = (id, cb) => {
  // ADMIN UNTAKE
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    // dispatch({ type: actionTypes.COMORDER_UNDELETE_FETCHING, payload: id })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postComorditemUpdateAdminUntake(id)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          // posle untake refreshovati spisak
          if (typeof cb === 'function') {
            cb();
          }
          dispatch(actionShowToast('comorditem uspešno otključan!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          // dispatch({ type: actionTypes.COMORDER_UNDELETE_FAIL })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


// ---------- DRAFT AND COMORDITEM ACTIONS ----------


export const actionSaveDraftToDb = (draft, virbom_seq, _virbom_parent_id, smartbom, sastavnica_internal, cb) => {
  // novo 2021april
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.DRAFT_SAVETODB_FETCHING });

    // korak 2 - 
    console.log('actionSaveDraftToDb')
    console.log('virbom_seq (SAMO OVO SE SALJE BACKENDU)');
    console.log(virbom_seq);
    let virtel_subkey_plus_genus_ident_arr = []; // NOVO DECEMBAR
    let virtel_with_genus_ident_arr = []; // NOVO DECEMBAR
    ajax.postGenusUpdateSmartArr(virbom_seq)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        console.log('ajax.postGenusUpdateSmartArr response')
        console.log(response);
        // korak 3 - 
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          virtel_subkey_plus_genus_ident_arr = res_payload; // NOVO DECEMBAR
          virtel_with_genus_ident_arr = _update_virtelArr_with_genus_ident(virbom_seq, virtel_subkey_plus_genus_ident_arr);
          // DOBILI SMO IDENTE
          dispatch({
            type: '***INFO TAKT PRE CUVANJA DRAFTA U BAZU',
            payload: {
              virbom_seq,
              virtel_subkey_plus_genus_ident_arr,
              virtel_with_genus_ident_arr,
            }
          }); // ovo je samo informativno ni jedna reducer ovo ne koristi
          let virbom_parent_id = 'NEMAMO_JOS';
          /*
          const virbom_header = draft.virbom_header;
          // if (draft.virbom_header.id && (draft.virbom_header.id > 0 || draft.virbom_header.id !== '')) {
          if (virbom_header.virbom_parent_id && (draft.virbom_header.virbom_parent_id > 0)) { // NOVO 2023
            // ovde podrazumevamo da je u pitanju id iz baze ILI INTEGER ILI STRING
            virbom_parent_id = draft.virbom_header.virbom_parent_id;
          }
          */
          if (_virbom_parent_id > 0) {
            virbom_parent_id = _virbom_parent_id;
          }
          const xentbox = {
            virbom_parent_id: virbom_parent_id,
            virtel_with_genus_ident_arr: virtel_with_genus_ident_arr,
            readme: 'saljemo da se sacuva kao version 2',
            smartbom,
            sasinternal: sastavnica_internal,
          }; // argument za mutator za fdb bazu podataka
          console.log(xentbox);
          // 
          ajax.postVirbomUpdate(xentbox)
            .then(response => ajax_fetch.response_json_smart(response))
            .then((response) => {
              // korak
              console.log('KORAK POSLE DOBIJANJA GENUSA');
              console.log('ajax.postVirbomUpdate response');
              console.log(response);
              if (frfr_res_utils.is_srf(response)) {
                const res_payload = frfr_res_utils.srf_extract_payload(response);
                // console.log(response);
                dispatch({
                  type: actionTypes.DRAFT_SAVETODB_SUCCESS,
                  payload: {
                    test: "test da je ovo je najnoviji build",
                    response_payload: res_payload,
                    virbom_seq,
                    virtel_subkey_plus_genus_ident_arr,
                    virtel_with_genus_ident_arr,
                  }
                })
                dispatch(actionShowToast('Draft uspešno sacuvan u bazu!', tclocal.GREEN));
                dispatch(actionRouteRefresh());
                //
                if (typeof cb === 'function') {
                  cb(res_payload);
                }
              } else {
                console.log(response);
                dispatch({ type: actionTypes.DRAFT_SAVETODB_FAIL });
                dispatch(actionShowToast('Greska! :(', tclocal.RED));
              }
            })
            .catch(errCatched)

        } else {
        }
      })


  };
};


/*
export const actionGenusNovo2021mart = (virbom_seq) => {
  // veci broj virtela salje u bazu jedan po jedan i sklapa listu genus identa od svakog kojeg dobije iz baze... 
  return (dispatch) => {
    // thunk
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    // dispatch({ type: actionTypes.GENUS_PP_CREATE_FETCHING }); // ***
    dispatch({ type: actionTypes.GENUS_IDENT_LIST_FETCHING }); // ***

    // korak 2 - fetchujemo podatke
    // // console.log(xentbox)
    ajax.postGenusUpdateSmartArr(virbom_seq)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          const virtel_subkey_plus_genus_ident_arr = res_payload; // NOVO DECEMBAR
          const virtel_with_genus_ident_arr = _update_virtelArr_with_genus_ident(virbom_seq, virtel_subkey_plus_genus_ident_arr);
          // DOBILI SMO IDENTE
          // console.log(response);
          dispatch({
            type: actionTypes.GENUS_IDENT_LIST_SUCCESS,
            payload: {
              virbom_seq,
              virtel_subkey_plus_genus_ident_arr,
              virtel_with_genus_ident_arr
            }
          });
          dispatch({
            type: actionTypes.VR2_DRAFT_LOAD,
            payload: {
              virbom_seq,
              virtel_subkey_plus_genus_ident_arr,
              virtel_with_genus_ident_arr
            }
          });
          dispatch(actionShowToast('Uspesan ??? update genusa u bazi!', tclocal.GREEN));
          // dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.GENUS_IDENT_LIST_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

    // return Promise.resolve();
  };
};
*/


export const actionGenusUpdateFromLib = (virbom_seq) => {
  // veci broj virtela salje u bazu jedan po jedan i sklapa listu genus identa od svakog kojeg dobije iz baze... 
  return (dispatch) => {
    // thunk
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    // dispatch({ type: actionTypes.GENUS_PP_CREATE_FETCHING }); // ***
    dispatch({ type: actionTypes.GENUS_IDENT_LIST_FETCHING }); // ***

    // korak 2 - fetchujemo podatke
    ajax.postGenusUpdateSmartArr(virbom_seq)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          let virtel_all_plus_ident_arr = res_payload;
          dispatch({
            type: '***INFO GENUS FROM LIB SUCCESS',
            payload: {
              virbom_seq,
              virtel_all_plus_ident_arr
            }
          }); // ovo je samo informativno ni jedna reducer ovo ne koristi
          dispatch(actionShowToast('Uspesan ??? update genusa u bazi!', tclocal.GREEN));
          // dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.GENUS_IDENT_LIST_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

    // return Promise.resolve();
  };
};


/*
export const actionDraftUnload = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.DRAFT_UNLOAD });
  };
};
*/


export const actionTerComorderUnload = (comorditemCurrent_id, cb) => {
  // zatavramo i narudzbu i stavku i pripadajuci virbom
  return (dispatch) => {
    // unloac comorder and comorditem
    dispatch({ type: actionTypes.COMORDER_UNLOAD });
    // unload virboma i ceo draft vracamo u inicijalno stanje
    dispatch({ type: actionTypes.DRAFT_UNLOAD });
    //
    // takodje vrsimo untake prethodno otvorenog comorditema (ukoliko ni jedan nije otvoren ovo nece napraviti problem)
    ajax.postComorditemUpdateUntake(comorditemCurrent_id)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          // posle untake refreshovati spisak
          if (typeof cb === 'function') {
            cb();
          }
        }
      })
  };
};


export const actionTerComorditemUnload = (comorditemCurrent_id, cb) => {
  // zatavramo i stavku i pripadajuci virbom
  return (dispatch) => {
    // unload comorditem
    dispatch({ type: actionTypes.COMORDITEM_UNLOAD });
    // unload virboma i ceo draft vracamo u inicijalno stanje
    dispatch({ type: actionTypes.DRAFT_UNLOAD });
    //
    // takodje vrsimo untake prethodno otvorenog comorditema (ukoliko ni jedan nije otvoren ovo nece napraviti problem)
    ajax.postComorditemUpdateUntake(comorditemCurrent_id)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          // posle untake refreshovati spisak
          if (typeof cb === 'function') {
            cb();
          }
        }
      })
      .catch(errCatched)

  };
};


export const actionTerComorditemLoadWithBlankVirbom = (comorditem) => {
  return (dispatch) => {
    // load commitem from list into comorditemCurrent ???
    dispatch({
      type: actionTypes.COMORDITEM_LOAD,
      payload: comorditem
    });
    dispatch({ type: actionTypes.DRAFT_LOAD_BLANK });
    //
  };
};


export const actionTerLoadImportedSmartbomStandalone = (smartbom) => {
  return (dispatch) => {
    //
    dispatch({
      type: actionTypes.DRAFT_LOAD_IMPORTED_SMARTBOM,
      payload: {
        smartbom
      }
    });
    //
  };
};


export const actionTerComorditemLoadWithVirbomNeeded = (virbom_parent_id, cb, comorditem, is_read_only) => {
  return (dispatch) => {
    // load commitem from list into comorditemCurrent ???
    if (is_read_only === true) {
      // READ ONLY
      dispatch({
        type: actionTypes.COMORDITEM_LOAD,
        payload: {
          ...comorditem,
          is_read_only: true // ucitaj comorditem u READ-ONLY modu
        }
      });
    } else {
      // normal read/write
      dispatch({
        type: actionTypes.COMORDITEM_LOAD,
        payload: { ...comorditem }
      });
    }
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.VIRBOM_SINGLE_FETCHING });
    // korak 2 - fetchujemo podatke
    ajax.getVirbomSingleByParentId(virbom_parent_id, is_read_only)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // console.log('response', response);
        // korak 3 - zavrseno fetchovanje
        let _error = false;
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log('extracted payload', res_payload);
          if (res_payload && res_payload.resbox) {
            if (!(res_payload.resbox.virbom_resbox_error === true) && !(res_payload.resbox.virbom_is_blank === true)) {
              // CASE sve uspesno
              // console.log(response);
              console.log('VIRBOM_SINGLE_SUCCESS - we will DRAFT_LOAD');
              dispatch({ type: actionTypes.VIRBOM_SINGLE_SUCCESS, payload: res_payload }); // mozda nebitan koristimo ga samo za informisanje ali reduceri nista ne menjaju sa ovim
              dispatch({
                type: actionTypes.DRAFT_LOAD,
                // payload: res_payload
                payload: res_payload.resbox
              }); // ucitava u draft state
              dispatch(actionShowToast('Draft uspešno ucitan iz baze u editor!', tclocal.GREEN));
              dispatch(actionRouteRefresh());
              if (typeof cb === 'function') {
                cb();
              }
            } else {
              if (res_payload.resbox.virbom_is_blank === true) {
                // CASE resbox.virbom_is_blank
                // console.log(response);
                console.log('VIRBOM_SINGLE_SUCCESS - we will DRAFT_LOAD_VIRBOM_IS_BLANK');
                dispatch({ type: actionTypes.VIRBOM_SINGLE_SUCCESS, payload: res_payload }); // mozda nebitan koristimo ga samo za informisanje ali reduceri nista ne menjaju sa ovim
                dispatch({
                  type: actionTypes.DRAFT_LOAD_VIRBOM_IS_BLANK,
                  // payload: res_payload
                  payload: res_payload.resbox
                }); // ucitava u draft state
                dispatch(actionShowToast('Draft BLANK uspešno ucitan iz baze u editor!', tclocal.GREEN));
                dispatch(actionRouteRefresh());
                if (typeof cb === 'function') {
                  cb();
                }
              } else {
                _error = true; // ERROR ???
              }
            }
          } else {
            _error = true; // ERROR nema resbox
          }
        } else {
          _error = true; // ERROR nije frfr_srf (nije success response)
        }
        if (_error === true) {
          // console.log(response);
          dispatch({ type: actionTypes.VIRBOM_SINGLE_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionGenusPpListNeeded = () => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.GENUS_PP_LIST_FETCHING });

    // korak 2 - fetchujemo podatke
    ajax.getGenusPpList()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: actionTypes.GENUS_PP_LIST_SUCCESS, payload: res_payload });
          // dispatch(actionShowToast('Sucess! :)'));
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.GENUS_PP_LIST_FAIL });
          dispatch(actionShowToast('Greska! :('));
        }
      })
      .catch(errCatched)

  };
};


// ---------- ACTIONS WITH EXTERNAL API ---------


export const actionExternalOrderFilesNeeded = (company_orderkey) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.EXTERNAL_FILES_LIST_FETCHING });

    // korak 2 - fetchujemo podatke
    ajax.getExternalOrderFiles(company_orderkey)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (response.data) {
          // console.log(response);
          dispatch({ type: actionTypes.EXTERNAL_FILES_LIST_SUCCESS, payload: response });
          console.log('EXTERNAL_FILES_LIST_SUCCESS - response:');
          console.log(response);
          // dispatch(actionShowToast('Sucess! :)'));
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.EXTERNAL_FILES_LIST_FAIL });
          dispatch(actionShowToast('Greska! :('));
        }
      })
      .catch(errCatched)

  };
};


export const _special_fix_actionExternalOrderFilesNeeded = (company_orderkey, cb) => {
  // NAPOMENA: OVO NIJE ACTION ZA DISPATCH nego funkcija po uzoru na taj action za upotrebu u StranaTerNarudzbe...
  // korak * - fetchujemo podatke
  ajax.getExternalOrderFiles(company_orderkey)
    .then(response => ajax_fetch.response_json_smart(response))
    .then((response) => {
      // korak 3 - zavrseno fetchovanje
      if (response.data) {
        // console.log(response);
        // dispatch({ type: actionTypes.EXTERNAL_FILES_LIST_SUCCESS, payload: response });
        // dispatch(actionShowToast('Sucess! :)'));
        if (typeof cb === 'function') {
          cb(response);
        }
      } else {
        // console.log(response);
        // dispatch({ type: actionTypes.EXTERNAL_FILES_LIST_FAIL });
        // dispatch(actionShowToast('Greska! :('));
      }
    })
    .catch(errCatched)

};


export const actionExternalSpreadsheetUpload = (entbox, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.EXTERNAL_SPREADSHEET_UPLOAD_FETCHING });

    // korak 2 - fetchujemo podatke
    ajax.postExternalSpreadsheetUpload(entbox)
      .then(response => {
        // const json = ajax_fetch.response_json_smart(response);
        // console.log('response -json try', json);
        console.log('postExternalSpreadsheetUpload response', response);
        if (response.status) {
          console.log('response.status', response.status);
          if (typeof cb === 'function') {
            cb(response.status);
          }
        } else {
          if (typeof cb === 'function') {
            cb('response status not available!');
          }
        }
        return response;
      })
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (response.data) {
          // console.log(response);
          dispatch({ type: actionTypes.EXTERNAL_SPREADSHEET_UPLOAD_SUCCESS, payload: response });
          console.log('EXTERNAL_SPREADSHEET_UPLOAD_SUCCESS - response:');
          console.log(response);
          // dispatch(actionShowToast('Sucess! :)'));
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.EXTERNAL_SPREADSHEET_UPLOAD_FAIL });
          dispatch(actionShowToast('Greska! :('));
        }
      })
      .catch(() => {
        //
        dispatch(actionShowToast('CATCH ERROR! Greška tokom exporta sastavnica na API :(', tclocal.RED));
        if (typeof cb === 'function') {
          cb(false);
        }
        errCatched();
      })

  };
};


// ---------- ADMIN PANEL ACTIONS ----------


export const actionLibVirtelParamsCreate = (entbox, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: '__ actionLibVirtelParamsCreate  FETCHING' })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postLibVirtelParamsCreate(entbox)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: '__ actionLibVirtelParamsCreate  SUCCESS', payload: res_payload })
          dispatch(actionShowToast('Parametri uspešno dodat!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
          if (typeof cb === 'function') {
            cb();
          }
        } else {
          // console.log(response);
          dispatch({ type: '__ actionLibVirtelParamsCreate  FAIL' })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionLibVirtelParamsUpdate = (entbox, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: '__ actionLibVirtelParamsUpdate FETCHING' })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postLibVirtelParamsUpdate(entbox)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: '__ actionLibVirtelParamsUpdate SUCCESS', payload: res_payload })
          dispatch(actionShowToast('Parametri uspešno izmenjen!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
          if (typeof cb === 'function') {
            cb();
          }
        } else {
          // console.log(response);
          dispatch({ type: '__ actionLibVirtelParamsUpdate FAIL' })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionLibMaterijalLimCreate = (entbox, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: '__ actionLibMaterijalLimCreate FETCHING' })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postLibMaterijalLimParamsCreate(entbox)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: '__ actionLibMaterijalLimCreate SUCCESS', payload: res_payload })
          dispatch(actionShowToast('Materijal Lim uspešno dodat!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
          if (typeof cb === 'function') {
            cb();
          }
        } else {
          // console.log(response);
          dispatch({ type: '__ actionLibMaterijalLimCreate FAIL' })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionLibMaterijalLimUpdate = (entbox, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: '__ actionLibMaterijalLimUpdate FETCHING' })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postLibMaterijalLimParamsUpdate(entbox)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: '__ actionLibMaterijalLimUpdate SUCCESS', payload: res_payload })
          dispatch(actionShowToast('Materijal Lim uspešno izmenjen!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
          if (typeof cb === 'function') {
            cb();
          }
        } else {
          // console.log(response);
          dispatch({ type: '__ actionLibMaterijalLimUpdate FAIL' })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionCNCProgramS4TemplateCreate = (entbox, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: '__ actionCNCProgramS4TemplateCreate FETCHING' })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postLibCNCProgramS4TemplateCreate(entbox)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: '__ actionCNCProgramS4TemplateCreate SUCCESS', payload: res_payload })
          dispatch(actionShowToast('CNC Program S4 template uspešno dodat!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
          if (typeof cb === 'function') {
            cb();
          }
        } else {
          // console.log(response);
          dispatch({ type: '__ actionCNCProgramS4TemplateCreate FAIL' })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionCNCProgramS4TemplateUpdate = (entbox, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: '__ actionCNCProgramS4TemplateUpdate FETCHING' })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postLibCNCProgramS4TemplateUpdate(entbox)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: '__ actionCNCProgramS4TemplateUpdate SUCCESS', payload: res_payload })
          dispatch(actionShowToast('CNC Program S4 template uspešno itzmenjen!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
          if (typeof cb === 'function') {
            cb();
          }
        } else {
          // console.log(response);
          dispatch({ type: '__ actionCNCProgramS4TemplateUpdate FAIL' })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionLibDocumentCreate = (entbox, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: '__ actionLibDocumentCreate FETCHING' })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postLibDocumentCreate(entbox)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: '__ actionLibDocumentCreate SUCCESS', payload: res_payload })
          dispatch(actionShowToast('Tabela entity uspešno dodat!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
          if (typeof cb === 'function') {
            cb();
          }
        } else {
          // console.log(response);
          dispatch({ type: '__ actionLibMaterijalLimCreate FAIL' })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionLibDocumentUpdate = (entbox, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: '__ actionLibDocumentUpdate FETCHING' })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postLibDocumentUpdate(entbox)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: '__ actionLibDocumentUpdate SUCCESS', payload: res_payload })
          dispatch(actionShowToast('*** Tabela entity uspešno izmenjen!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
          if (typeof cb === 'function') {
            cb();
          }
        } else {
          // console.log(response);
          dispatch({ type: '__ actionLibDocumentUpdate FAIL' })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionLibCparamsCreate = (entbox, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: '__ actionLibCparamsCreate FETCHING' })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postLibCparamsCreate(entbox)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: '__ actionLibCparamsCreate SUCCESS', payload: res_payload })
          dispatch(actionShowToast('Cparams entity uspešno dodat!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
          if (typeof cb === 'function') {
            cb();
          }
        } else {
          // console.log(response);
          dispatch({ type: '__ actionLibCparamsCreate FAIL' })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


export const actionLibCparamsUpdate = (entbox, cb) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: '__ actionLibCparamsUpdate FETCHING' })

    // korak 2 - fetchujemo podatke
    // console.log(entbox, id);
    ajax.postLibCparamsUpdate(entbox)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: '__ actionLibCparamsUpdate SUCCESS', payload: res_payload })
          dispatch(actionShowToast('*** Cparams entity cparams uspešno izmenjen!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
          if (typeof cb === 'function') {
            cb();
          }
        } else {
          // console.log(response);
          dispatch({ type: '__ actionLibCparamsUpdate FAIL' })
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};


// -------------------------NOVO 2023
